import React from 'react';

import Container from '../container';
import styled, { css } from 'styled-components';
import RichtextParser from '../../utils/richtext-parser';
import Marquee from 'react-fast-marquee';
import StatItem from './StatItem';
import mq from '../../utils/mq';

const OuterContainer = styled.div`
  padding: 104px 0;
  background-color: #fff;
  ${mq.mobile(css`
    padding: 64px 0;
  `)};
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 536px;
  margin: 0 auto;
  gap: 12px;
  text-align: center;
  ${mq.mobile(css`
    text-align: left;
    max-width: unset;
    align-items: flex-start;
  `)};
`;

const Title = styled.h2`
  color: #161616;
  text-align: inherit;

  font-size: 42px;
  font-style: normal;
  font-weight: 700;
  line-height: 115%;
  letter-spacing: -0.84px;
  ${mq.mobile(css`
    font-size: 36px;
  `)};
`;

const Description = styled.div`
  color: #666;
  text-align: inherit;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: -0.36px;
`;

const StyledMarquee = styled(Marquee)`
  height: 38px;
  width: calc(100% + 104px);
  margin-left: -52px;
  overflow: hidden;
  ${mq.mobile(css`
    width: 100%;
    margin-left: 0;
  `)};
`;

const MarqueeContainer = styled.div`
  width: 100%;
  padding: 64px 0;
  overflow-y: hidden;
  overflow-x: hidden;
`;

const Logo = styled.div`
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  margin: 0 34px;
  img {
    height: 100%;
    object-fit: contain;
  }
`;

const StatsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 48px;
  align-items: start;
  ${mq.mobile(css`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 24px;
  `)}
`;

export default function LogoMarqueeWithTitleAndStats({
  sectionTitle,
  sectionDescription,
  marqueeLogos,
  statItems
}: {
  sectionTitle: string;
  sectionDescription: string;
  marqueeLogos: any[];
  statItems: any[];
}) {
  return (
    <OuterContainer>
      <Container>
        <TitleSection>
          <Title>{sectionTitle}</Title>
          <Description
            dangerouslySetInnerHTML={{
              __html: RichtextParser(sectionDescription)
            }}
          />
        </TitleSection>
      </Container>
      <Container style={{ overflowX: 'visible' }}>
        <MarqueeContainer>
          <StyledMarquee gradient gradientColor="#fff" autoFill>
            {marqueeLogos.map((logo) => (
              <Logo key={logo.id}>
                <img src={logo.filename} />
              </Logo>
            ))}
          </StyledMarquee>
        </MarqueeContainer>
      </Container>
      <Container>
        <StatsContainer>
          {statItems &&
            statItems?.length > 0 &&
            statItems?.map((stat) => (
              <StatItem
                key={stat.id}
                {...stat}
                startValue={stat.startingValue}
                durationMs={stat?.animationDuration?.value || 3000}
                enableAnimation={stat?.enableAnimation}
              />
            ))}
        </StatsContainer>
      </Container>
    </OuterContainer>
  );
}
